import { useState } from "react";
import { api } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";
import { BookOpen } from "lucide-react";
import ChurchBrand from "@/components/ChurchBrand";

export default function AccessGate({ onUnlock }) {
  const [code, setCode] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!code.trim()) return;
    setLoading(true);
    try {
      await api.post("/access/verify", { code });
      localStorage.setItem("group_access_ok", "1");
      onUnlock();
    } catch (err) {
      toast.error(err.response?.data?.detail || "Código incorrecto");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      data-testid="access-gate"
      className="min-h-screen flex items-center justify-center px-4 py-8 relative"
      style={{
        backgroundImage:
          "linear-gradient(rgba(26,24,24,0.80), rgba(26,24,24,0.80)), url('https://images.pexels.com/photos/6269056/pexels-photo-6269056.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940')",
        backgroundSize: "cover",
        backgroundPosition: "center",
      }}
    >
      <div className="w-full max-w-lg bg-white rounded-2xl border-2 border-[#D1C9C1] shadow-xl p-8 sm:p-10">
        <ChurchBrand size="md" className="mb-5 text-[#1A1818]" />

        <div className="flex flex-col items-center text-center mb-6">
          <div className="w-14 h-14 rounded-full bg-[#8A3A33]/10 flex items-center justify-center mb-4">
            <BookOpen className="w-7 h-7 text-[#8A3A33]" strokeWidth={1.8} />
          </div>
          <h1 className="font-serif text-2xl sm:text-3xl font-bold text-[#1A1818] leading-tight">
            Sobrellevad los Unos las Cargas de los Otros
          </h1>
          <p className="mt-3 text-base text-[#4A4646] italic font-serif">
            &ldquo;Sobrellevad los unos las cargas de los otros, y cumplid así la ley de Cristo.&rdquo;
          </p>
          <p className="text-sm text-[#8A3A33] font-semibold mt-1">— Gálatas 6:2</p>
        </div>

        <form onSubmit={submit} className="space-y-5">
          <div>
            <Label htmlFor="code" className="text-lg font-semibold text-[#1A1818] mb-2 block">
              Código de Acceso del Grupo
            </Label>
            <Input
              id="code"
              data-testid="access-code-input"
              type="text"
              value={code}
              onChange={(e) => setCode(e.target.value)}
              placeholder="Ingrese el código"
              className="h-14 text-lg border-2 border-[#D1C9C1] focus-visible:border-[#8A3A33]"
              autoFocus
            />
            <p className="text-sm text-[#4A4646] mt-2">
              Solicite el código al líder de su estudio bíblico.
            </p>
          </div>
          <Button
            data-testid="access-code-submit"
            type="submit"
            disabled={loading}
            className="w-full h-14 text-lg font-semibold bg-[#8A3A33] hover:bg-[#6B2B25] text-white rounded-lg"
          >
            {loading ? "Verificando..." : "Entrar"}
          </Button>
        </form>
      </div>
    </div>
  );
}
